module.exports = __webpack_public_path__ + "static/media/lcg-shape-dark-blue-down.52fd1fb6.svg";